export const enum Endpoint {
  Config = '/assets/config/config.json',
  Users = '/users',
  CurrentUser = '/users/me',
  Employees = '/employees',
  Timesheets = '/timesheets',
  Submit = '/submit',
  Reopen = '/reopen',
  Report = '/report',
  Eligibility = '/eligibility-periods',
  UpdateRole = '/employees/updateRole',
  Recall = '/recall',
  Settings = '/settings',
  ExportReport = '/export/monthly-report',
  ExportTimesheet = '/export/timesheet',
  DefaultDeadline = '/default-deadline',
  CustomDeadline = '/custom-deadline',
  ArchivedReports = '/archive/reports',
  RestoreDeadline = '/restore-default-deadline',
  UpdateCache = '/updateCache',
  Constants = '/constants-fe',
  DefaultNotifications = '/default-notifications',
  CustomNotifications = '/custom-notifications',
  RestoreNotifications = '/restore-default-notifications',
  DefaultMessage = '/default-message-subject'
}

export const SERVER_URL = `${window.location.origin}/api`;
